import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { useAppDispatch } from "../hooks/hooks";
import { user } from "../redux/user/actions";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { addressBooks } from "../redux/address-books/action";
import storePersist from "../redux/storePersist";
import * as R from 'ramda';
import GoogleMapSearch from "../common/components/google-map-search";
import _ from "lodash";
import { toast } from "react-toastify";
import useWindowDimensions from "../hooks/useWindowsDimensions";

export default function ProfileAddress() {
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const [steps, setSteps] = useState<any>({})
	const { height, width } = useWindowDimensions();
	const dispatch = useAppDispatch();
	const handleClose = () => {
		dispatch(user.set({ viewProfile: 'close' }))
	}
	const statesItems = storePersist?.get("states")?.current?.items;
	const countriesItems = storePersist?.get("countries")?.current?.items;
	const [
		stateValues,
		setStateValues
	] = useState<any>([])
	const [locations, setLocations] = useState<any>({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});
	const handleFilterToStates = () => {

		const event = 133
		if (event) {
			const filterStates: any = R.filter(
				(value: any) => value.CountryId === event,
				statesItems
			);
			if (filterStates.length) {
				setStateValues(filterStates);
			} else {
				setStateValues(statesItems);
			}
		} else {
			setStateValues([])
		}
	}
	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e })
	}

	const userProfileData = storePersist?.get("userProfile")?.current;
	const handleSave = async (event: any) => {
		event.preventDefault();
		// Validation for required fields
		if (
			!steps?.firstName ||
			!steps?.lastName ||
			!locations?.description ||
			!steps?.Phone ||
			!steps?.Address1 ||
			!steps?.Address2 ||
			!steps?.City ||
			!steps?.PinCode ||
			!steps?.StateProvinceId
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return;
		}
		await dispatch(addressBooks.create({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-features/addressbooks/add-address-to-addressbook`, entity: 'addressBooks', jsonData: {

				"Records": [
					{
						AddressBookId: userProfileData?.items[0]?.Message?.AddressBookId,
						Addresses: [{
							Id: 0,
							FirstName: steps?.firstName,
							LastName: steps?.lastName,
							Email: steps?.emailAddress,
							PhoneNumber: steps?.Phone,
							Address1: steps?.Address1,
							Address2: steps?.Address2,
							City: steps?.City,
							Latitude: steps?.Latitude,
							Longitude: steps?.Longitude,
							ZipPostalCode: steps?.PinCode,
							StateProvinceId: steps?.StateProvinceId,
							CountryId: steps?.CountryId,
						}]
					}
				]

			}
		}))
		await fetchAddress()
		await handleClose()


	}
	const fetchAddress = () => {
		dispatch(addressBooks.list({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-features/addressbooks/query`, entity: 'addressBooks', jsonData: {

				"Records": [
					{
						"Id": userProfileData?.items[0]?.Message?.AddressBookId
					}
				]

			}
		}))
	}
	useEffect(() => {
		if (locations?.description) {
			const addressData = _.split(locations?.description, ',');
			let stateName = addressData[4]?.replace(/\d+/g, '').trim().toLowerCase();
			let stateData = _.find(statesItems, item => item.Name.toLowerCase() === stateName);
			setSteps(prev => ({
				...prev,

				Address1: `${addressData[0]}`,
				Address2: `${addressData[1]},${addressData[2]}`,
				City: `${addressData[3]}`,
				PinCode: locations?.pincode,
				StateProvinceId: stateData?.Id,
				Latitude: locations?.lat,
				Longitude: locations?.lng,
				CountryId: 133

			}));

		} else if (!locations?.description) {
			setSteps(prev => ({
				...prev,
				Address1: '',
				Address2: '',
				City: '',
				PinCode: '',
				StateProvinceId: 0,
				CountryId: 133,


			}));
		}

	}, [locations]);

	useEffect(() => {
		handleFilterToStates()
	}, [steps, locations]);

	return (
		<>
			{width && width < 720 ?
				//Mobile View 
				<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
					<div className="w-full max-w-3xl mt-3 mx-4 bg-primary text-white rounded-xl shadow-lg">
						<div className="flex items-start justify-between w-full border-b p-2 border-blue-500">
							<div className="flex w-full flex-col items-start justify-between text-xl p-2">
								Add Address
							</div>
							<div className="cursor-pointer p-2">
								<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x-circle">
									<circle cx="12" cy="12" r="10" />
									<path d="m15 9-6 6" />
									<path d="m9 9 6 6" />
								</svg>
							</div>
						</div>

						<form onSubmit={handleSave} className="space-y-6 scrollbar-hide overflow-y-auto max-h-[60vh] p-6">
							<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
								{/* First Name */}
								<div>
									<label className="block text-sm font-normal  mb-1">First Name</label>
									<input
										required
										{...register('firstName', { required: true, maxLength: 15 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="First Name"
										onChange={(e) => handleSteps(e.target.value, 'firstName')}
									/>
									{errors.firstName && (
										<p className="text-red-500 text-xs mt-1">{errors.firstName.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* Last Name */}
								<div>
									<label className="block text-sm font-normal  mb-1">Last Name</label>
									<input
										required
										{...register('lastName', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Last Name"
										onChange={(e) => handleSteps(e.target.value, 'lastName')}
									/>
									{errors.lastName && (
										<p className="text-red-500 text-xs mt-1">{errors.lastName.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* Email Address */}
								<div className="md:col-span-2">
									<label className="block text-sm font-normal  mb-1">Email Address</label>
									<input
										required
										type="email"
										{...register('emailAddress', {
											required: true,
											pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
										})}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Email Address"
										onChange={(e) => handleSteps(e.target.value, 'emailAddress')}
									/>
									{errors.emailAddress && (
										<p className="text-red-500 text-xs mt-1">
											{errors.emailAddress.type === "required" ? "This is required" : "Please enter a valid email"}
										</p>
									)}
								</div>

								{/* Phone */}
								<div className="md:col-span-2">
									<label className="block text-sm font-normal mb-1">Phone</label>
									<input
										required
										maxLength={10}
										type="text"
										pattern="\d{10}"

										{...register('Phone', {
											required: true,
											maxLength: 10,
											minLength: 10,
											pattern: /^[0-9+-]+$/
										})}
										className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Phone"
										onChange={(e) => handleSteps(e.target.value.replace(/\D/g, ''), 'Phone')}
									/>
									{errors.Phone && (
										<p className="text-red-500 text-xs mt-1">Please enter a valid mobile number</p>
									)}
								</div>
								{/* Address Search */}
								<div className="md:col-span-2">
									<label className="block text-sm font-normal mb-1">Address Search</label>
									<GoogleMapSearch
										className="appearance-none font-normal Block w-full text-black rounded shadow focus:outline-none focus:ring ps-8  pe-10 py-2"
										setLocation={setLocations}
										location={locations}
										placeholder="Search your address"
										required
									/>
								</div>
								{/* Address1 */}
								<div>
									<label className="block text-sm font-normal mb-1">Building</label>
									<textarea
										required
										{...register('Address1', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Building"
										disabled={!locations?.description}
										defaultValue={steps?.Address1}
										onChange={(e) => handleSteps(e.target.value, 'Address1')}
									/>
									{errors.Address1 && (
										<p className="text-red-500 text-xs mt-1">{errors.Address1.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* Address2 */}
								<div>
									<label className="block text-sm font-normal  mb-1">Locality</label>
									<textarea
										required
										{...register('Address2', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Locality"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'Address2')}
										value={steps?.Address2}
									/>
									{errors.Address2 && (
										<p className="text-red-500 text-xs mt-1">{errors.Address2.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* City */}
								<div>
									<label className="block text-sm font-normal  mb-1">City</label>
									<input
										required
										{...register('City', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="City"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'City')}
										value={steps?.City}
									/>
									{errors.City && (
										<p className="text-red-500 text-xs mt-1">{errors.City.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* PinCode */}
								<div>
									<label className="block text-sm font-normal mb-1">PinCode</label>
									<input
										required
										{...register('PinCode', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2  font-normal text-black rounded shadow focus:outline-none focus:ring"
										placeholder="PinCode"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'PinCode')}
										value={steps?.PinCode}
									/>
									{errors.PinCode && (
										<p className="text-red-500 text-xs mt-1">{errors.PinCode.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>
								{/* Country */}
								<div>
									<label className="block text-sm font-normal  mb-1">Country</label>
									<select
										required
										disabled
										{...register('CountryId', { required: true })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										id="default"
										onChange={(e) => handleSteps(e.target.value, 'CountryId')}
										defaultValue={133}
									>

										<option>--Select--</option>
										{countriesItems?.map((item: any, index: any) => (
											<option value={item.Id} key={index}>{item.Name}</option>
										)
										)}

									</select>
									{errors.CountryId && (
										<p className="text-red-500 text-xs mt-1">{errors.CountryId.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>
								{/* Sate */}
								<div>
									<label className="block text-sm font-normal  mb-1">State</label>
									<select
										required
										className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
										id="default"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'StateProvinceId')}
										value={steps?.StateProvinceId}

									>

										<option>--Select--</option>
										{statesItems?.map((item: any, index: any) => (
											<option value={item.Id} key={index}>{item.Name}</option>
										)
										)}

									</select>
									{errors.StateProvinceId && (
										<p className="text-red-500 text-xs mt-1">{errors.StateProvinceId.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>
							</div>

							<div className="pt-4">
								<button
									type="submit"
									className="w-full bg-hilight text-black text-lg font-semibold py-2 rounded shadow hover:bg-yellow-300 transition"
								>
									Register
								</button>
							</div>
						</form>
					</div>
				</div>
				:
				//Web View
				<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
					<div className="w-full max-w-3xl mt-3 bg-primary text-white rounded-xl shadow-lg">
						<div className="flex justify-between items-center border-b border-blue-500 px-6 py-4">
							<h2 className="text-2xl font-semibold">Add Address</h2>
							<button onClick={handleClose} className="text-white hover:text-gray-300">
								<svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<circle cx="12" cy="12" r="10" />
									<path d="M15 9L9 15M9 9l6 6" />
								</svg>
							</button>
						</div>

						<form onSubmit={handleSave} className="space-y-6 overflow-y-auto max-h-[60vh] p-6">
							<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
								{/* First Name */}
								<div>
									<label className="block text-sm font-normal  mb-1">First Name</label>
									<input
										required
										{...register('firstName', { required: true, maxLength: 15 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="First Name"
										onChange={(e) => handleSteps(e.target.value, 'firstName')}
									/>
									{errors.firstName && (
										<p className="text-red-500 text-xs mt-1">{errors.firstName.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* Last Name */}
								<div>
									<label className="block text-sm font-normal  mb-1">Last Name</label>
									<input
										required
										{...register('lastName', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Last Name"
										onChange={(e) => handleSteps(e.target.value, 'lastName')}
									/>
									{errors.lastName && (
										<p className="text-red-500 text-xs mt-1">{errors.lastName.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* Email Address */}
								<div className="md:col-span-2">
									<label className="block text-sm font-normal  mb-1">Email Address</label>
									<input
										required
										type="email"
										{...register('emailAddress', {
											required: true,
											pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
										})}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Email Address"
										onChange={(e) => handleSteps(e.target.value, 'emailAddress')}
									/>
									{errors.emailAddress && (
										<p className="text-red-500 text-xs mt-1">
											{errors.emailAddress.type === "required" ? "This is required" : "Please enter a valid email"}
										</p>
									)}
								</div>

								{/* Phone */}
								<div className="md:col-span-2">
									<label className="block text-sm font-normal mb-1">Phone</label>
									<input
										required
										maxLength={10}
										type="text"
										pattern="\d{10}"

										{...register('Phone', {
											required: true,
											maxLength: 10,
											minLength: 10,
											pattern: /^[0-9+-]+$/
										})}
										className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Phone"
										onChange={(e) => handleSteps(e.target.value.replace(/\D/g, ''), 'Phone')}
									/>
									{errors.Phone && (
										<p className="text-red-500 text-xs mt-1">Please enter a valid mobile number</p>
									)}
								</div>
								{/* Address Search */}
								<div className="md:col-span-2">
									<label className="block text-sm font-normal mb-1">Address Search</label>
									<GoogleMapSearch
										className="appearance-none font-normal Block w-full text-black rounded shadow focus:outline-none focus:ring ps-8  pe-10 py-2"
										setLocation={setLocations}
										location={locations}
										placeholder="Search your address"
										required
									/>
								</div>
								{/* Address1 */}
								<div>
									<label className="block text-sm font-normal mb-1">Building</label>
									<textarea
										required
										{...register('Address1', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Building"
										disabled={!locations?.description}
										defaultValue={steps?.Address1}
										onChange={(e) => handleSteps(e.target.value, 'Address1')}
									/>
									{errors.Address1 && (
										<p className="text-red-500 text-xs mt-1">{errors.Address1.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* Address2 */}
								<div>
									<label className="block text-sm font-normal  mb-1">Locality</label>
									<textarea
										required
										{...register('Address2', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="Locality"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'Address2')}
										value={steps?.Address2}
									/>
									{errors.Address2 && (
										<p className="text-red-500 text-xs mt-1">{errors.Address2.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* City */}
								<div>
									<label className="block text-sm font-normal  mb-1">City</label>
									<input
										required
										{...register('City', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										placeholder="City"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'City')}
										value={steps?.City}
									/>
									{errors.City && (
										<p className="text-red-500 text-xs mt-1">{errors.City.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>

								{/* PinCode */}
								<div>
									<label className="block text-sm font-normal mb-1">PinCode</label>
									<input
										required
										{...register('PinCode', { required: true, maxLength: 30 })}
										className="w-full px-3 py-2  font-normal text-black rounded shadow focus:outline-none focus:ring"
										placeholder="PinCode"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'PinCode')}
										value={steps?.PinCode}
									/>
									{errors.PinCode && (
										<p className="text-red-500 text-xs mt-1">{errors.PinCode.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>
								{/* Country */}
								<div>
									<label className="block text-sm font-normal  mb-1">Country</label>
									<select
										required
										disabled
										{...register('CountryId', { required: true })}
										className="w-full px-3 py-2 font-normal  text-black rounded shadow focus:outline-none focus:ring"
										id="default"
										onChange={(e) => handleSteps(e.target.value, 'CountryId')}
										defaultValue={133}
									>

										<option>--Select--</option>
										{countriesItems?.map((item: any, index: any) => (
											<option value={item.Id} key={index}>{item.Name}</option>
										)
										)}

									</select>
									{errors.CountryId && (
										<p className="text-red-500 text-xs mt-1">{errors.CountryId.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>
								{/* Sate */}
								<div>
									<label className="block text-sm font-normal  mb-1">State</label>
									<select
										required
										className="w-full px-3 py-2 font-normal text-black rounded shadow focus:outline-none focus:ring"
										id="default"
										disabled={!locations?.description}
										onChange={(e) => handleSteps(e.target.value, 'StateProvinceId')}
										value={steps?.StateProvinceId}

									>

										<option>--Select--</option>
										{statesItems?.map((item: any, index: any) => (
											<option value={item.Id} key={index}>{item.Name}</option>
										)
										)}

									</select>
									{errors.StateProvinceId && (
										<p className="text-red-500 text-xs mt-1">{errors.StateProvinceId.type === "required" ? "This is required" : "Max length exceeded"}</p>
									)}
								</div>
							</div>

							<div className="pt-4">
								<button
									type="submit"
									className="w-full bg-hilight text-black text-lg font-semibold py-2 rounded shadow hover:bg-yellow-300 transition"
								>
									Register
								</button>
							</div>
						</form>
					</div>
				</div>}
		</>



	);
}